/**
 * Title card overlay — black screen, white serif text, cold open.
 * Spec: BLUEPRINT.md § Cold open, TODO § Title card overlay.
 */

const MIN_HOLD_MS = 1500;

export function mountTitleCard(): { dismiss: () => Promise<void> } {
  const overlay = document.createElement("div");
  Object.assign(overlay.style, {
    position: "fixed",
    inset: "0",
    background: "#000",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "32px",
    zIndex: "9999",
    fontFamily: "\"Cormorant Garamond\", \"EB Garamond\", Georgia, serif",
    textAlign: "center",
    padding: "40px",
  } as CSSStyleDeclaration);

  const eyebrow = document.createElement("div");
  eyebrow.textContent = "— ACT 1 —";
  Object.assign(eyebrow.style, {
    fontSize: "20px",
    letterSpacing: "0.4em",
    opacity: "0.85",
  } as CSSStyleDeclaration);

  const title = document.createElement("div");
  title.textContent = "Where's My Money?";
  Object.assign(title.style, {
    fontSize: "56px",
    fontStyle: "italic",
    letterSpacing: "0.02em",
  } as CSSStyleDeclaration);

  overlay.append(eyebrow, title);
  document.body.append(overlay);

  const mountedAt = Date.now();

  return {
    async dismiss() {
      const elapsed = Date.now() - mountedAt;
      const remaining = MIN_HOLD_MS - elapsed;
      if (remaining > 0) {
        await new Promise((r) => setTimeout(r, remaining));
      }
      overlay.remove();
    },
  };
}
